var _circle, _rect, _rect2, _rect3, _rect4, _path, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2C2C2C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.7549,
    y: 23.1201,
    width: 4.49004,
    height: 4.49004,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7046,
    y: 23.1201,
    width: 4.49004,
    height: 4.49004,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7046,
    y: 28.1709,
    width: 4.49004,
    height: 4.49004,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7549,
    y: 28.1709,
    width: 4.49004,
    height: 4.49004,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8703 12.001H18.0526C14.7099 12.001 12 14.7108 12 18.0536V38.1379C12 39.1865 12.2667 40.1729 12.7359 41.0328L17.3616 36.4072C17.3448 36.2823 17.3361 36.1548 17.3361 36.0253V20.1671C17.3361 18.6047 18.6026 17.3381 20.165 17.3381H34.8703V12.001ZM38.8522 21.3184V36.0253C38.8522 37.5877 37.5857 38.8543 36.0233 38.8543H20.165C20.0939 38.8543 20.0235 38.8517 19.9537 38.8465L15.2805 43.5198C16.111 43.9484 17.0536 44.1905 18.0526 44.1905H38.1369C41.4797 44.1905 44.1895 41.4807 44.1895 38.1379V18.0536C44.1895 18.0123 44.1891 17.971 44.1883 17.9299V21.3184H38.8522Z",
    fill: "#DEDEDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.1384,
    cy: 15.3884,
    r: 3.38837,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.383f56721a38ec75113d2e5cab8f1ac0.svg";
export { ForwardRef as ReactComponent };